import {
  Aparat,
  Feed,
  Instagram,
  KojaroWithText,
  Linkedin,
  PedalWithText,
  Telegram,
  XIcon,
  Youtube,
  ZoobinLogo,
  ZoomgWithText,
  ZoomitWithText,
} from '@zoomit/icons';
import { OriginURL } from '@zoomit/web-kit';
import { cssVar, theme } from '@zoomit/zoomit-ds';

export const zoobinHelperLinks = [
  { name: 'ثبت فروشگاه', href: `${OriginURL}/product/shop-landing` },
  { name: 'تبلیغات در زوبین', href: `${OriginURL}/advertisement/` },
  { name: 'تماس با ما', href: `${OriginURL}/contact-us/` },
  { name: 'درباره ما', href: `${OriginURL}/product/about-us/` },
];

export const helperLinks = [
  { name: 'مرور تمامی مطالب', href: `${OriginURL}/archive/` },
  { name: 'تبلیغات در زومیت', href: `${OriginURL}/advertisement/` },
  { name: 'تماس با ما', href: `${OriginURL}/contact-us/` },
  { name: 'درباره ما', href: `${OriginURL}/about-us/` },
];

export const zoomitSupporters = [
  { name: 'پارس پک | میزبانی و پشتیبانی', href: 'https://parspack.com/' },
  { name: 'وب رخ | حس خوب پیکسل‌ها', href: '' },
];

export const zoomitProducts = [
  {
    name: 'زومیت',
    icon: <ZoomitWithText width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.zoomit.ir',
  },
  {
    name: 'زومجی',
    icon: <ZoomgWithText width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.zoomg.ir',
  },
  {
    name: 'کجارو',
    icon: <KojaroWithText width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.kojaro.com/?utm_source=zoomit&utm_medium=footer&utm_campaign=footerlink',
  },
  {
    name: 'پدال',
    icon: <PedalWithText width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.pedal.ir',
  },
];

export const zoobinProducts = [
  {
    name: 'زوبین',
    icon: <ZoobinLogo width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.zoomit.ir/product',
  },
  {
    name: 'زومیت',
    icon: <ZoomitWithText width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.zoomit.ir',
  },
  {
    name: 'زومجی',
    icon: <ZoomgWithText width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.zoomg.ir',
  },
  {
    name: 'کجارو',
    icon: <KojaroWithText width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.kojaro.com/?utm_source=zoomit&utm_medium=footer&utm_campaign=footerlink',
  },
  {
    name: 'پدال',
    icon: <PedalWithText width={110} height={32} fill={cssVar(theme.text)} />,
    href: 'https://www.pedal.ir',
  },
];

export const socialMedia = [
  { name: 'feed', icon: <Feed size="lg" />, href: 'https://www.zoomit.ir/feed/' },
  { name: 'linkedin', icon: <Linkedin size="lg" />, href: 'https://www.linkedin.com/company/zoomit' },
  { name: 'instagram', icon: <Instagram size="lg" />, href: 'https://www.instagram.com/thezoomit/' },
  { name: 'aparat', icon: <Aparat size="lg" />, href: 'https://www.aparat.com/zoomit' },
  { name: 'youtube', icon: <Youtube size="lg" />, href: 'https://www.youtube.com/c/ZoomitTV' },
  { name: 'telegram', icon: <Telegram size="lg" />, href: 'https://t.me/thezoomit/' },
  { name: 'twitter', icon: <XIcon size="lg" />, href: 'https://twitter.com/thezoomit/' },
];

export const mobileBanners = [
  {
    name: 'اینستاگرام',
    icon: <Instagram size="sm" fill="#D7385D" />,
    href: 'https://www.instagram.com/myzoobin/',
  },
  { name: 'یوتیوب', icon: <Youtube size="sm" fill="#E4012B" />, href: 'https://www.youtube.com/c/ZoomitTV' },
  { name: 'ایکس', icon: <XIcon size="sm" fill="#3D84B7" />, href: 'https://twitter.com/thezoomit/' },
];

export const mobileSocialMedia = [
  { name: 'feed', icon: Feed, href: 'https://www.zoomit.ir/feed/' },
  { name: 'linkedin', icon: Linkedin, href: 'https://www.linkedin.com/company/zoomit' },
  { name: 'aparat', icon: Aparat, href: 'https://www.aparat.com/zoomit' },
  { name: 'telegram', icon: Telegram, href: 'https://t.me/thezoomit/' },
];
